
import Rate from "./form/Rate.vue";
import Button from "./buttons/Button.vue";
import { defineComponent, ref, watch } from "vue";
import { useBook } from "../utils/composable/useBook";
import { useForm, useField } from "vee-validate";
export default defineComponent({
  name: "RateModal",
  props: {
    bookId: {
      type: Number,
      required: true,
    },
  },
  components: {
    Rate,
    Button,
  },
  setup(prp) {
    const isModalOpen = ref(false);
    const { handleSubmit } = useForm({ initialValues: { rate: 3 } });

    const { rateBook } = useBook();

    const handleRateBook = handleSubmit((data) => {
      isModalOpen.value = false;
      return rateBook(prp.bookId, data.rate);
    });

    const { value: rate } = useField("rate");

    return { handleRateBook, rate, isModalOpen };
  },
});
